const getHeatMapColors = theme => [
  theme.palette.green.tone50,
  theme.palette.green.tone200,
  theme.palette.green.tone300,
  theme.palette.green.tone700,
  theme.palette.green.tone800,
]

export const getQuintileRanges = (min, max, theme) => {
  const step = max ? (max - min) / 5 : 10
  const quintiles = []

  for (let i = 0; i < 5; i++) {
    quintiles.push({ value: min + i * step, color: getHeatMapColors(theme)[i] })
  }

  return quintiles
}

export const getColorByValue = (value, quintiles) => {
  if (value > 0) {
    return quintiles.find(q => value <= q.value)?.color || quintiles[quintiles.length - 1].color
  }

  return '#ccc'
}

export const getHeatMapMetrics = (countriesMetrics, orderBy, theme) => {
  let quintiles = []
  let heatMapMetrics = []

  if (countriesMetrics?.length) {
    const values = countriesMetrics.map(country => country[orderBy])
    const maxValue = Math.max(...values)
    const minValue = Math.min(...values)
    quintiles = getQuintileRanges(minValue, maxValue, theme)

    heatMapMetrics = countriesMetrics.map(country => ({
      ...country,
      value: country[orderBy],
      color: getColorByValue(country[orderBy], quintiles),
    }))
  }

  return {
    heatMapMetrics,
    quintiles,
  }
}

export const getCountryCodeByRegionId = (regions, regionId) => {
  const region = regions.find(region => region.id === regionId)

  return region?.code
}
